import * as React from "react";
import { useSelector } from "react-redux";
import { Authorize } from "reauthorize";

import { Grid, Button, Table, Input, InputOnChangeData } from "semantic-ui-react";

import { useDispatch } from "@teamprevent/admin-redux";

import { AppState } from "../model";
import { ADMIN_ROLES } from "../../auth";

import { loadTeams } from "../actions";

import { Link } from "redux-little-router";

export const All = () => {
    const dispatch = useDispatch();
    const path = useSelector((state: AppState) => state.router.pathname);
    const teams = useSelector((state: AppState) => state.teams.sort((a, b) => a.name.localeCompare(b.name)));
    const [nameSearch, setNameSearch] = React.useState("");
    const onNameSearchChange = React.useCallback((_: any, data: InputOnChangeData) => setNameSearch(data.value), []);

    React.useEffect(() => {
        dispatch(loadTeams());
    }, [dispatch]);

    return (
        <Grid container className="nomargintop">
            <Grid.Row>
                <Grid.Column width={14}>
                    <h1>Teams</h1>
                </Grid.Column>
                <Grid.Column width={2} textAlign="right">
                    <Authorize authorize={[ADMIN_ROLES.SYSTEM_ADMIN.name]}>
                        <Button icon="add" content="Create" as={Link} href={`${path}/create`} />
                    </Authorize>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={16}>
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Name</Table.HeaderCell>
                                <Table.HeaderCell>Members</Table.HeaderCell>
                                <Table.HeaderCell>Customers</Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell>
                                    <Input
                                        value={nameSearch}
                                        onChange={onNameSearchChange}
                                        icon="search"
                                        placeholder="Search..."
                                        size="mini"
                                    />
                                </Table.HeaderCell>
                                <Table.HeaderCell />
                                <Table.HeaderCell />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {teams
                                .filter(team => team.name.toUpperCase().includes(nameSearch.toUpperCase()))
                                .map(team => (
                                    <Table.Row key={team.id}>
                                        <Table.Cell>
                                            <Link href={`${path}/${team.id}`}>
                                                {team.name}
                                            </Link>
                                        </Table.Cell>
                                        <Table.Cell>
                                            {team.members.length}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {team.customers.length}
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                        </Table.Body>
                    </Table>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};
